import React from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const Sidebar = ({ page, setPage, pendingCount }) => {
    const { admin, logout } = useAuth();

    const navItems = [
        { id: 'dashboard', icon: '📊', label: 'Tableau de bord' },
        { id: 'messages', icon: '📨', label: 'Tous les messages', badge: pendingCount > 0 ? pendingCount : null },
        { id: 'reclamations', icon: '🔴', label: 'Réclamations' },
        { id: 'satisfactions', icon: '⭐', label: 'Satisfactions' },
        { id: 'suggestions', icon: '💡', label: 'Suggestions' },
        { id: 'utilisateurs', icon: '👥', label: 'Utilisateurs', superOnly: true },
    ];

    return (
        <div style={{ width: 260, background: 'linear-gradient(180deg,#0a1628 0%,#0f2744 100%)', display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 100, borderRight: '1px solid rgba(0,212,255,0.1)' }}>
            <div style={{ padding: '28px 24px 20px', borderBottom: '1px solid rgba(0,212,255,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 44, height: 44, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, fontWeight: 900, color: 'white', boxShadow: '0 0 20px rgba(0,212,255,0.3)', flexShrink: 0 }}>CS</div>
                    <div>
                        <div style={{ fontSize: 16, fontWeight: 800, color: 'white' }}>CS FORM</div>
                        <div style={{ fontSize: 10, color: 'rgba(0,212,255,0.6)', textTransform: 'uppercase', letterSpacing: 1 }}>Administration</div>
                    </div>
                </div>
                <div style={{ marginTop: 16, height: 1, background: 'linear-gradient(90deg,rgba(0,212,255,0.5),transparent)' }}></div>
            </div>

            <nav style={{ flex: 1, padding: '16px 12px', overflowY: 'auto' }}>
                <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '1.5px', color: 'rgba(0,212,255,0.4)', padding: '12px 12px 6px', fontWeight: 600 }}>Navigation</div>
                {navItems.filter(item => !item.superOnly || admin?.role === 'super_admin').map(item => (
                    <div key={item.id} onClick={() => setPage(item.id)} style={{
                        display: 'flex', alignItems: 'center', gap: 10,
                        padding: '10px 12px', borderRadius: 10,
                        color: page === item.id ? 'white' : 'rgba(255,255,255,0.5)',
                        cursor: 'pointer', marginBottom: 2,
                        background: page === item.id ? 'linear-gradient(135deg,rgba(30,111,224,0.4),rgba(0,212,255,0.2))' : 'transparent',
                        border: page === item.id ? '1px solid rgba(0,212,255,0.3)' : '1px solid transparent',
                        boxShadow: page === item.id ? '0 0 15px rgba(0,212,255,0.1)' : 'none',
                        transition: 'all 0.2s', fontSize: 14, fontWeight: 500
                    }}>
                        <span style={{ width: 20, textAlign: 'center', fontSize: 16, flexShrink: 0 }}>{item.icon}</span>
                        {item.label}
                        {item.badge && (
                            <span style={{ marginLeft: 'auto', background: '#ef4444', color: 'white', fontSize: 10, fontWeight: 700, padding: '2px 7px', borderRadius: 20, boxShadow: '0 0 10px rgba(239,68,68,0.4)' }}>
                                {item.badge}
                            </span>
                        )}
                    </div>
                ))}

                <div style={{ fontSize: 10, textTransform: 'uppercase', letterSpacing: '1.5px', color: 'rgba(0,212,255,0.4)', padding: '16px 12px 6px', fontWeight: 600 }}>Outils</div>
                <div onClick={() => window.open('/', '_blank')} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: 14, fontWeight: 500, border: '1px solid transparent', transition: 'all 0.2s' }}>
                    <span style={{ width: 20, textAlign: 'center', fontSize: 16 }}>🌐</span>
                    Formulaire public
                </div>
            </nav>

            <div style={{ padding: '16px 12px', borderTop: '1px solid rgba(0,212,255,0.1)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, background: 'rgba(255,255,255,0.03)', marginBottom: 8 }}>
                    <div style={{ width: 36, height: 36, background: 'linear-gradient(135deg,#1e6fe0,#00d4ff)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, color: 'white', flexShrink: 0, boxShadow: '0 0 15px rgba(0,212,255,0.2)' }}>
                        {admin?.prenom?.[0]}{admin?.nom?.[0]}
                    </div>
                    <div style={{ overflow: 'hidden' }}>
                        <div style={{ fontSize: 13, color: 'white', fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{admin?.prenom} {admin?.nom}</div>
                        <div style={{ fontSize: 11, color: 'rgba(0,212,255,0.6)' }}>
                            {admin?.role === 'super_admin' ? '👑 Super Admin' : admin?.role === 'admin' ? '🛡️ Admin' : '👁️ Visiteur'}
                        </div>
                    </div>
                </div>
                <button onClick={() => { logout(); toast.success('Déconnecté'); }} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '9px 12px', width: '100%', borderRadius: 10, border: '1px solid rgba(239,68,68,0.2)', background: 'rgba(239,68,68,0.06)', color: 'rgba(255,100,100,0.7)', cursor: 'pointer', fontSize: 13, fontFamily: 'inherit', transition: 'all 0.2s' }}>
                    🚪 Se déconnecter
                </button>
            </div>
        </div>
    );
};

export default Sidebar;